import { Fragment, useState } from 'react';

import { InvoiceService } from '../../hoa-don/InvoiceService';

import { ConfirmDialogService } from '../../../AppConfirmDialog';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';

import { DialogView } from '../../hoa-don/component/DialogView';
import { DialogCancel } from '../../hoa-don/component/DialogCancel';
import { DialogSelectInvoice } from '../../hoa-don/component/DialogSelectInvoice';

import { DialogStatement } from '../components/DialogStatement';
import { DialogAttachment } from '../components/DialogAttachment';
import { useTranslation } from '../../../shared/language';

export const List = () => {

  const { t } = useTranslation();
  const header = t('menu.invoiceCancellation');
  const dataKey = 'invoiceId';

  const [displaySelectInvoice, setDisplaySelectInvoice] = useState(null);
  const [selectedInvoices, setSelectedInvoices] = useState(null);
  const [displayCancel, setDisplayCancel] = useState(false);

  const [displayStatement, setDisplayStatement] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [displayView, setDisplayView] = useState(false);

  const [displayUpload, setDisplayUpload] = useState(false);
  const [documentType, setDocumentType] = useState(InvoiceService.documentType_Cancel);
  const { render: renderDataTable, reloadLazyData, selectedItems } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'invoiceSerial', header: t('common.symbol'), width: 100, matchMode: 'contains' },
      { field: 'invoiceNumber', header: t('common.invoiceNo'), width: 110, matchMode: 'contains' },
      { field: 'invoiceDate', header: t('common.invoiceDate'), width: 120, dataType: 'date' },
      {
        field: 'sendTaxStatus', header: t('common.submissionStatus'), width: 180, matchMode: 'contains', filterType: 'dropdown', filterOptions: InvoiceService.sendTaxStatuses, dataType: 'custom', customCell(rowData: any): any {
          if ([3, 4, 5].includes(rowData.sendTaxStatus)) {
            return <span className={`underline send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{InvoiceService.getSendTaxStatusLabel(rowData.sendTaxStatus)}</span>;
          }
          return <span className={`send-tax-status send-tax-status-${rowData.sendTaxStatus}`}>{InvoiceService.getSendTaxStatusLabel(rowData.sendTaxStatus)}</span>;
        }
      },
      {
        field: 'buyerLegalName', header: t('catalog.customer'), minWidth: 200, matchMode: 'contains', dataType: 'custom', customCell(rowData: any): any {
          return rowData.buyerLegalName || rowData.buyerDisplayName;
        }
      },
      { field: 'documentNoView', header: t('common.noticeNumber'), width: 120, matchMode: 'contains' },
      {
        field: '', header: t('common.statement'), width: 110, sortable: false, dataType: 'custom', customCell(rowData): any {
          const text = rowData.hasDocument ? t('common.statementCreated') : t('common.statementCreate');
          return (
            <span className="underline text-primary" onClick={() => setDisplayStatement(true)}>{text}</span>
          );
        }, style: { justifyContent: 'center' }
      },
      { field: 'invoiceNote', header: t('common.cancelReason'), width: 110, matchMode: 'contains' },
      {
        field: '', header: t('common.actions'), width: 100, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return (
            <div className='flex gap-3'>
              <i className="pi pi-link " title={t('common.attachment')} onClick={() => setDisplayUpload(true)}></i>
              <i className="pi pi-eye " title={t('common.view')} onClick={() => viewInvoice(rowData)}></i>
            </div>
          );
        }, style: { justifyContent: 'center' }
      }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      params.IsOtherInvoice = false;
      return InvoiceService.getListCancels(params);
    },
    selectionMode: 'single'
  });

  const viewInvoice = (rowData) => {
    setSelectedInvoice({
      id: rowData.invoiceId,
      buyerTaxCode: rowData.buyerTaxCode,
      invoiceSerial: rowData.invoiceSerial,
      invoiceNumber: rowData.invoiceNumber
    });
    setDisplayView(true);
  }

  const { renderToolbar } = useToolbar({
    dataKey,
    reloadLazyData,
    // otherActions: [
    //   {
    //     label: 'Huỷ hoá đơn', icon: 'pi pi-fw pi-times', className: 'iam-toolbar', command: () => {
    //       setDisplaySelectInvoice(true);
    //     }
    //   }
    // ]
  });

  const onAddSelectedItems = (items) => {
    if (items && items.length) {
      let _DisplayCancel = true;

      for (const iv of items) {
        if (![0, 4].includes(iv.invoiceStatus) || ![4].includes(iv.sendTaxStatus)) {
          console.log(iv.invoiceSerial, iv.invoiceNumber);
          _DisplayCancel = false;
          ConfirmDialogService.showInvalid(t('common.cancelInvoiceSelectionRestriction'));
          break;
        }
      }

      if (_DisplayCancel) {
        setSelectedInvoices(items);
        setDisplayCancel(true);
      }
    }
  }

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}

      <DialogSelectInvoice display={displaySelectInvoice} setDisplay={setDisplaySelectInvoice} addSelectedItems={onAddSelectedItems} selectionMode="checkbox"
        invoiceStatus="0,4" sendTaxStatus="4" />
      <DialogCancel display={displayCancel} setDisplay={setDisplayCancel} selectedItems={selectedInvoices} />

      <DialogAttachment display={displayUpload} setDisplay={setDisplayUpload} selectedItem={selectedItems} />

      <DialogStatement display={displayStatement} setDisplay={setDisplayStatement} selectedItem={selectedItems} documentType={documentType} reloadLazyData={reloadLazyData} title={t('common.cancelled')} />

      <DialogView display={displayView} setDisplay={setDisplayView} selectedItem={selectedInvoice} />
    </Fragment>
  )
}
